import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['field']

  show(event) {
    event.preventDefault()
    this.fieldTarget.hidden = false
  }
}
